module.exports = __webpack_public_path__ + "img/wallpaper-8.3cdbcb33.png";